// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var OpinionScaleLabel$ReactHooksTemplate = require("./OpinionScaleLabel.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");

function OpinionScalePreview$OpinionScaleItem(props) {
  var onSelection = props.onSelection;
  var step = props.step;
  return JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("span", {
                          children: String(step)
                        })
                  }),
              className: props.className,
              style: props.style,
              onClick: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(onSelection, step);
                })
            });
}

var OpinionScaleItem = {
  make: OpinionScalePreview$OpinionScaleItem
};

function colorBasedOnLikelyness(index) {
  switch (index) {
    case 0 :
    case 1 :
    case 2 :
    case 3 :
    case 4 :
        return "#f5d0d0";
    case 5 :
    case 6 :
        return "#d9daf8";
    case 7 :
    case 8 :
    case 9 :
    case 10 :
        return "#c7f8d8";
    default:
      return "#ffffff";
  }
}

function OpinionScalePreview(props) {
  var onChange = props.onChange;
  var opinionScale = props.opinionScale;
  var selectedCss = function (x) {
    if (OpinionScale$ReactHooksTemplate.isAnswer(opinionScale, x)) {
      return "text-vistablue border-2 border-bleudefrance";
    } else {
      return "";
    }
  };
  var items = function (a, b) {
    return $$Array.of_list(Belt_List.mapWithIndex(Belt_List.makeBy((b - a | 0) + 1 | 0, (function (x) {
                          return x;
                        })), (function (i, x) {
                      return JsxRuntime.jsx(OpinionScalePreview$OpinionScaleItem, {
                                  step: x + a | 0,
                                  className: selectedCss(x) + " w-48-px h-48-px rounded-xl focus:outline-none text-darkcharcoal text-lg\n    font-medium",
                                  onSelection: (function (scale) {
                                      Curry._1(onChange, OpinionScale$ReactHooksTemplate.setAnswer(opinionScale, scale));
                                    }),
                                  style: {
                                    backgroundColor: colorBasedOnLikelyness(i)
                                  }
                                }, String(i + a | 0));
                    })));
  };
  var onTitleChange = function (html) {
    Curry._1(onChange, OpinionScale$ReactHooksTemplate.setText(opinionScale, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, OpinionScale$ReactHooksTemplate.setDescription(opinionScale, html));
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: OpinionScale$ReactHooksTemplate.text(opinionScale),
                      description: OpinionScale$ReactHooksTemplate.description(opinionScale),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Range/Steps",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx("div", {
                              children: items(0, 10),
                              className: "flex gap-2 max-w-600-px"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: OpinionScaleLabel$ReactHooksTemplate.left(OpinionScale$ReactHooksTemplate.label(opinionScale))
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: OpinionScaleLabel$ReactHooksTemplate.center(OpinionScale$ReactHooksTemplate.label(opinionScale)),
                                      className: "pl-12"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: OpinionScaleLabel$ReactHooksTemplate.right(OpinionScale$ReactHooksTemplate.label(opinionScale))
                                    })
                              ],
                              className: " flex justify-between  w-full pt-6 pb-10 text-spanishgray text-sm "
                            }),
                        props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {}) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                      ],
                      className: "flex flex-col justify-between items-start max-w-600-px"
                    })
              ],
              className: "w-full p-16"
            });
}

var make = OpinionScalePreview;

exports.OpinionScaleItem = OpinionScaleItem;
exports.colorBasedOnLikelyness = colorBasedOnLikelyness;
exports.make = make;
/* react/jsx-runtime Not a pure module */
